/** Bloqueia loadBoard do react-trello durante drag + fila de fetchs adiados. */
let nLocks = 0
let mKanbanAplicaPendentes = []
let fnAplicarKanbanPendente = null

export const trelloDragLock = {
  acquire() {
    nLocks += 1
  },

  release() {
    nLocks = Math.max(0, nLocks - 1)
    if (nLocks === 0 && mKanbanAplicaPendentes.length && fnAplicarKanbanPendente) {
      const mPorSituacao = new Map()
      mKanbanAplicaPendentes.forEach((oPayload) => {
        mPorSituacao.set(String(oPayload.situacaoId), oPayload)
      })
      mKanbanAplicaPendentes = []
      fnAplicarKanbanPendente([...mPorSituacao.values()])
    }
  },

  isLocked() {
    return nLocks > 0
  },

  registrarAplicadorKanban(fn) {
    fnAplicarKanbanPendente = fn
  },

  adiarAplicacaoKanban(oPayload) {
    mKanbanAplicaPendentes.push(oPayload)
  },

  /** Libera locks pendentes ao sair da tela (ex.: Kanban → Fluxo). */
  releaseAll() {
    nLocks = 0
    if (mKanbanAplicaPendentes.length && fnAplicarKanbanPendente) {
      const mPorSituacao = new Map()
      mKanbanAplicaPendentes.forEach((oPayload) => {
        mPorSituacao.set(String(oPayload.situacaoId), oPayload)
      })
      mKanbanAplicaPendentes = []
      fnAplicarKanbanPendente([...mPorSituacao.values()])
    }
  },
}

/** Tempo extra após a fila de moves esvaziar antes de liberar o Board. */
export const TRELLO_SETTLE_MS = 400
